import { render, staticRenderFns } from "./NominationConferenceEdit.vue?vue&type=template&id=6e45776f&scoped=true"
import script from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
export * from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceEdit.vue?vue&type=style&index=0&id=6e45776f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45776f",
  null
  
)

export default component.exports